export const API_ENDPOINT = {
  LINEBOT: process.env.REACT_APP_API as string,
  ADDRESS: process.env.REACT_APP_ADDRESS_API as string,
} as const;
export type ApiEndpoint = keyof typeof API_ENDPOINT;
